(() => {
  class BrassGallery {
    constructor(root) {
      if (root.dataset.galleryReady) return;
      this.root = root;
      this.stage = root.querySelector('[data-gallery-stage]');
      this.shots = Array.from(root.querySelectorAll('[data-shot]'));
      this.thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
      this.shots.sort((a, b) => Number(a.dataset.shot) - Number(b.dataset.shot));
      this.thumbs.sort((a, b) => Number(a.dataset.thumb) - Number(b.dataset.thumb));
      this.thumbs.forEach(thumb => thumb.parentElement.append(thumb));
      this.dots = Array.from(root.querySelectorAll('[data-gallery-dot]'));
      this.status = root.querySelector('[data-gallery-status]');
      this.index = 0;
      if (!this.stage || !this.shots.length) return;
      root.dataset.galleryReady = 'true';
      root.classList.add('product__media--live');
      root.querySelectorAll('.brass-gallery__arrows, .brass-gallery__dots').forEach((control) => {
        control.hidden = this.shots.length < 2;
      });

      this.thumbs.forEach((button) => button.addEventListener('click', () => this.show(Number(button.dataset.thumb))));
      this.dots.forEach((button) => button.addEventListener('click', () => this.show(Number(button.dataset.galleryDot))));
      root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.show(this.index - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1));
      this.stage.addEventListener('keydown', (event) => {
        if (event.target.closest('a, button')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.show(event.key === 'Home' ? 0 : this.shots.length - 1);
        }
      });

      this.stage.addEventListener('dragstart', (event) => event.preventDefault());
      this.stage.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0 || event.target.closest('a, button')) return;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.stage.setPointerCapture(event.pointerId);
      });
      this.stage.addEventListener('pointerup', (event) => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) >= 44 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
      });
      this.stage.addEventListener('pointercancel', () => { this.pointer = null; });
      this.show(0, false);
    }

    show(index, announce = true) {
      this.index = (index + this.shots.length) % this.shots.length;
      this.shots.forEach((shot, position) => {
        shot.hidden = position !== this.index;
        shot.setAttribute('aria-hidden', String(position !== this.index));
      });
      this.thumbs.forEach((button, position) => button.setAttribute('aria-current', String(position === this.index)));
      this.dots.forEach((button, position) => button.setAttribute('aria-current', String(position === this.index)));
      if (announce && this.status) {
        this.status.textContent = this.root.dataset.statusTemplate
          .replace('[index]', String(this.index + 1))
          .replace('[count]', String(this.shots.length));
      }
      const image = this.shots[this.index].querySelector('img');
      if (image) image.loading = 'eager';
      const thumbnail = this.thumbs[this.index];
      const rail = thumbnail?.parentElement;
      if (thumbnail && rail) {
        if (rail.scrollHeight > rail.clientHeight) {
          rail.scrollTop = Math.max(0, thumbnail.offsetTop - rail.offsetTop - (rail.clientHeight - thumbnail.offsetHeight) / 2);
        } else if (rail.scrollWidth > rail.clientWidth) {
          rail.scrollLeft = Math.max(0, thumbnail.offsetLeft - rail.offsetLeft - (rail.clientWidth - thumbnail.offsetWidth) / 2);
        }
      }
    }
  }

  const initialize = (scope = document) => scope.querySelectorAll('[data-brass-gallery]').forEach((root) => new BrassGallery(root));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
